module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('footerBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-main"
  }, [_c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/1e54ebe59c5c072b48d73c36ae8ec4b640004.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fb72d4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/403.vue
// module id = 978
// module chunks = 0